mutation UpdateTranslationWords($input: UpdateTranslationWordsInput!) {
  updateTranslationWords(input: $input) {
    id
    variants {
      languageCode
      translated
      untranslated
      total
      words {
        key
        value
      }
    }
  }
}
